import React from 'react'

const Mentions = () => (
  <div>
    <div className="tc" style={{ marginBottom: 24 }}>
      <span className="eyebrow">Informations légales</span>
      <h2 style={{ marginTop: 8, fontSize: 'clamp(1.5rem, 1.2rem + 2vw, 2rem)' }}>Mentions légales, CGU & confidentialité</h2>
    </div>

    {/* Mentions légales */}
    <div className="legal-block">
      <h3>1. Mentions légales</h3>
      <p><strong>Éditeur du site</strong><br />
      The Stable Company<br />
      44 Woodland Rise, London N10 3UG, Royaume-Uni<br />
      Email : <a href="mailto:contact@fetchy.vet">contact@fetchy.vet</a><br />
      Directeur de la publication : Louis-Gabriel Mognetti</p>

      <p><strong>Hébergement</strong><br />
      Le site fetchy.vet est hébergé par Amazon Web Services (AWS)<br />
      Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855 Luxembourg<br />
      L'application app.fetchy.vet est hébergée par Heroku (Salesforce)<br />
      The Landmark @ One Market, Suite 300, San Francisco, CA 94105, États-Unis</p>

      <p><strong>TVA</strong><br />
      TVA non applicable — article 293 B du CGI.</p>
    </div>

    {/* CGU */}
    <div className="legal-block">
      <h3>2. Conditions Générales d'Utilisation</h3>

      <h4>2.1 Objet</h4>
      <p>Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») encadrent l'utilisation du service Fetchy, outil numérique de prescription nutritionnelle pour carnivores domestiques (ci-après « le Service »), édité par The Stable Company (ci-après « l'Éditeur »).</p>

      <h4>2.2 Acceptation</h4>
      <p>L'inscription au Service vaut acceptation pleine et entière des présentes CGU. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le Service.</p>

      <h4>2.3 Description du Service</h4>
      <p>Fetchy est un outil d'aide à la prescription nutritionnelle destiné aux vétérinaires en exercice et aux étudiants vétérinaires. Le Service permet de calculer des rations alimentaires pour chiens et chats, de générer des prescriptions au format PDF et de les transmettre aux propriétaires d'animaux.</p>

      <h4>2.4 Accès et inscription</h4>
      <p>L'accès au Service nécessite la création d'un compte. L'utilisateur s'engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants. Toute activité réalisée sous son compte est réputée effectuée par lui.</p>

      <h4>2.5 Abonnement et paiement</h4>
      <p>Le Service est proposé sous forme d'abonnement mensuel. Le paiement est traité par Stripe. L'abonnement est sans engagement et résiliable à tout moment depuis l'espace personnel de l'utilisateur. La résiliation prend effet à la fin de la période en cours. Aucun remboursement n'est dû pour la période entamée.</p>

      <h4>2.6 Accès étudiant</h4>
      <p>Les étudiants vétérinaires bénéficient d'un accès gratuit sur présentation d'un justificatif de scolarité. Cet accès est valable jusqu'à la date de fin d'études déclarée et peut être révoqué en cas de fausse déclaration.</p>

      <h4>2.7 Responsabilité</h4>
      <p>Le Service est un outil d'aide à la décision clinique. Il ne se substitue en aucun cas au jugement du vétérinaire prescripteur. La prescription nutritionnelle relève de la médecine vétérinaire ; en cas de problème, le propriétaire doit consulter son vétérinaire habituel ou le prescripteur.</p>
      <p>L'Éditeur ne saurait être tenu responsable de dommages directs ou indirects résultant de l'utilisation du Service, notamment en cas d'erreur de saisie, d'interprétation des résultats ou de non-respect des recommandations par le propriétaire.</p>

      <h4>2.8 Propriété intellectuelle</h4>
      <p>L'ensemble du Service (code, design, bases de données, algorithmes, contenus) est protégé par le droit de la propriété intellectuelle. Toute reproduction ou extraction non autorisée est interdite.</p>
      <p>Les prescriptions générées par l'utilisateur restent sa propriété intellectuelle. L'Éditeur ne revendique aucun droit sur leur contenu clinique.</p>

      <h4>2.9 Disponibilité</h4>
      <p>L'Éditeur s'efforce d'assurer une disponibilité maximale du Service. Toutefois, il ne garantit pas un accès ininterrompu et ne saurait être tenu responsable en cas d'indisponibilité temporaire pour maintenance, mise à jour ou cas de force majeure.</p>

      <h4>2.10 Modification des CGU</h4>
      <p>L'Éditeur se réserve le droit de modifier les présentes CGU. Les utilisateurs seront informés par email de toute modification substantielle. La poursuite de l'utilisation du Service après modification vaut acceptation des nouvelles CGU.</p>

      <h4>2.11 Droit applicable</h4>
      <p>Les présentes CGU sont régies par le droit anglais. Tout litige sera soumis à la compétence des tribunaux de Londres, Royaume-Uni.</p>
    </div>

    {/* Confidentialité */}
    <div className="legal-block">
      <h3>3. Politique de confidentialité</h3>

      <h4>3.1 Responsable du traitement</h4>
      <p>The Stable Company, 44 Woodland Rise, London N10 3UG, Royaume-Uni.<br />
      Contact : <a href="mailto:contact@fetchy.vet">contact@fetchy.vet</a></p>

      <h4>3.2 Données collectées</h4>
      <p>Dans le cadre du Service, nous collectons :</p>
      <ul>
        <li><strong>Données d'inscription :</strong> nom, prénom, adresse email, mot de passe (chiffré)</li>
        <li><strong>Données d'abonnement :</strong> informations de facturation traitées par Stripe (nous ne stockons pas vos données bancaires)</li>
        <li><strong>Données d'utilisation :</strong> profils d'animaux créés, rations calculées, prescriptions générées</li>
        <li><strong>Données d'accès étudiant :</strong> certificat de scolarité, école, date de fin d'études</li>
        <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages consultées (à des fins d'amélioration du Service)</li>
      </ul>

      <h4>3.3 Finalités du traitement</h4>
      <ul>
        <li>Fourniture et amélioration du Service</li>
        <li>Gestion des comptes et de la facturation</li>
        <li>Envoi d'emails liés au Service (prescriptions, notifications de compte)</li>
        <li>Newsletter (avec consentement séparé, désinscription en un clic)</li>
        <li>Vérification des justificatifs étudiants</li>
      </ul>

      <h4>3.4 Base légale</h4>
      <p>Le traitement repose sur l'exécution du contrat (fourniture du Service), le consentement (newsletter) et l'intérêt légitime (amélioration du Service, sécurité).</p>

      <h4>3.5 Durée de conservation</h4>
      <p>Les données de compte sont conservées pendant la durée de l'abonnement et 3 ans après la dernière activité. Les données de facturation sont conservées conformément aux obligations légales comptables (10 ans). Les certificats de scolarité sont supprimés après vérification et approbation du compte.</p>

      <h4>3.6 Partage des données</h4>
      <p>Vos données ne sont ni vendues ni louées. Elles sont partagées uniquement avec :</p>
      <ul>
        <li><strong>Stripe</strong> — traitement des paiements</li>
        <li><strong>Amazon Web Services</strong> — hébergement et stockage</li>
        <li><strong>Resend</strong> — envoi d'emails transactionnels</li>
      </ul>
      <p>Tous nos sous-traitants sont conformes au RGPD ou aux clauses contractuelles types.</p>

      <h4>3.7 Transferts internationaux</h4>
      <p>Certaines données peuvent être transférées hors de l'Espace économique européen (vers les États-Unis) dans le cadre de l'utilisation d'AWS et Stripe. Ces transferts sont encadrés par des clauses contractuelles types ou le Data Privacy Framework UE-US.</p>

      <h4>3.8 Vos droits</h4>
      <p>Conformément au RGPD, vous disposez des droits suivants :</p>
      <ul>
        <li>Droit d'accès à vos données</li>
        <li>Droit de rectification</li>
        <li>Droit à l'effacement (« droit à l'oubli »)</li>
        <li>Droit à la portabilité</li>
        <li>Droit d'opposition et de limitation du traitement</li>
        <li>Droit de retirer votre consentement à tout moment</li>
      </ul>
      <p>Pour exercer ces droits, contactez-nous à <a href="mailto:contact@fetchy.vet">contact@fetchy.vet</a>. Nous répondons dans un délai de 30 jours.</p>

      <h4>3.9 Cookies</h4>
      <p>Le Service utilise des cookies strictement nécessaires au fonctionnement (authentification, session). Aucun cookie publicitaire ou de traçage tiers n'est utilisé.</p>

      <h4>3.10 Sécurité</h4>
      <p>Nous mettons en oeuvre des mesures techniques et organisationnelles pour protéger vos données : chiffrement des mots de passe, connexion HTTPS, accès restreint aux données en production.</p>
    </div>

    <p style={{ marginTop: 32, fontSize: 13, color: 'var(--text-subtle)' }}>
      Dernière mise à jour : juillet 2026
    </p>
  </div>
)

export default Mentions
